import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Delete16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M7.3155 6.64391C7.3155 6.273 7.01482 5.97233 6.64391 5.97233C6.273 5.97233 5.97233 6.273 5.97233 6.64391V11.1642C5.97233 11.5351 6.273 11.8358 6.64391 11.8358C7.01482 11.8358 7.3155 11.5351 7.3155 11.1642V6.64391Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M10.0277 6.64391C10.0277 6.273 9.727 5.97233 9.35609 5.97233C8.98518 5.97233 8.6845 6.273 8.6845 6.64391V11.1642C8.6845 11.5351 8.98518 11.8358 9.35609 11.8358C9.727 11.8358 10.0277 11.5351 10.0277 11.1642V6.64391Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M6.64391 1C6.22602 1 5.82525 1.16601 5.52976 1.4615C5.23427 1.75699 5.06827 2.15776 5.06827 2.57565V2.80812H3.02768H1.67159C1.30068 2.80812 1 3.1088 1 3.47971C1 3.85061 1.30068 4.15129 1.67159 4.15129H2.40975L3.19374 13.5546C3.22648 13.9485 3.4061 14.316 3.69694 14.5837C3.98782 14.8514 4.36873 15 4.76407 15H11.2365C11.6319 15 12.0128 14.8514 12.3037 14.5837C12.5946 14.3159 12.7742 13.9486 12.8069 13.5546L13.5903 4.15129H14.3284C14.6993 4.15129 15 3.85061 15 3.47971C15 3.1088 14.6993 2.80812 14.3284 2.80812H10.9317V2.57565C10.9317 2.15776 10.7657 1.75699 10.4702 1.4615C10.1747 1.16601 9.77398 1 9.35609 1H6.64391ZM4.53229 13.4433C4.53711 13.5014 4.56364 13.5559 4.60656 13.5954C4.64948 13.6349 4.70568 13.6568 4.76401 13.6568H10.3322H10.6704H11.2365C11.2949 13.6568 11.3511 13.6349 11.394 13.5954C11.437 13.5559 11.4635 13.5017 11.4683 13.4436L12.2425 4.15129H6.66357H3.93204H3.75758L4.53229 13.4433ZM6.41144 2.80812H9.58856V2.57565C9.58856 2.51399 9.56407 2.45486 9.52047 2.41126C9.47687 2.36767 9.41774 2.34317 9.35609 2.34317H6.64391C6.58226 2.34317 6.52313 2.36767 6.47953 2.41126C6.43593 2.45486 6.41144 2.51399 6.41144 2.57565V2.80812Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
